<div class="d-flex flex-column h-100 mainClass">
  <app-nav-bar *ngIf="auth.isAuthenticated$ | async"></app-nav-bar>

  <div class="flex-grow-1 flex-shrink-1">
    <router-outlet></router-outlet>
  </div>

  <app-footer></app-footer>
</div>
